// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import RoundedDecrement from '../_raw/ui/icon_rounded_decrement.svg';
import withIconProps from '../withIconProps';

export default withIconProps(RoundedDecrement);
